import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ViewStore, for use in the registry */ export const ViewStoreActionTypes = [
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.ReportValidCustomFieldDefinitionsAction,
    ActionType.SetCategoryLabelModeAction,
    ActionType.SetLeftNavExpandedAction,
    ActionType.SetPlanFilterAction,
    ActionType.SetSortCriteriaAction,
    ActionType.SetTaskFilterAction,
    ActionType.SetTaskGroupingStateAction,
    ActionType.SetGridColumnWidthAction,
    ActionType.SetFABStateAction,
    ActionType.SetCopilotPaneStateAction,
    ActionType.SetCopilotSidecarStateAction,
    ActionType.FetchRoamingUserDataSucceededAction,
    ActionType.UpdateRoamingUserDataAction,
    ActionType.UpdateRoamingUserDataSucceededAction,
    ActionType.UpdateRoamingUserDataFailedAction,
    ActionType.SetScreenWidthAction,
    ActionType.SetAddGoalRowVisibilityAction,
    ActionType.SetTaskEditorRenderModeAction,
    ActionType.SetGanttZoomScaleAction,
    ActionType.SetTaskEditorSelectedTabAction,
    ActionType.SetAgentOutputUnseenAction
];
